import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import CodeMappingViewForm from './CodeMappingViewForm'
import { useParams } from 'react-router-dom'
import Namespace from 'src/constants/locale/Namespace'
import CodeMappingKeys from 'src/constants/locale/key/CodeMapping'

const { CngTabs } = components


function ViewPage({ showNotification }) {
  const { id } = useParams()
  const { translate } = useTranslation([Namespace.CODE_MAPPING])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let codeMapping = translate(
      Namespace.CODE_MAPPING,
      CodeMappingKeys.TITLE
    )

    return {
      codeMapping
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <CodeMappingViewForm
              showNotification={showNotification}
              id={id}
              onFetchPreSuccess={(datum) => {
                //do nothing
              }}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.codeMapping,
              tabContent: (
                <CodeMappingViewForm
                  showNotification={showNotification}
                  id={id}
                />
              )
            },
          ]}
        />
      </Grid>
    </Grid>
  );
}

export default ViewPage